import script from "./RoleRequiredWrapper.vue?vue&type=script&setup=true&lang=ts"
export * from "./RoleRequiredWrapper.vue?vue&type=script&setup=true&lang=ts"

import "./RoleRequiredWrapper.vue?vue&type=style&index=0&id=1e37644c&lang=css"

const __exports__ = script;

export default __exports__